import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE_ROOT = 'https://africaresearchuniversity.com';

const defaultMeta = {
    title: 'Africa Research University',
    description: 'Africa Research University - Excellence in research and higher education across Africa.',
    image: '/assets/img/arulogo.png',
    url: SITE_ROOT,
    type: 'website',
};

const SEO = ({ 
    title, 
    description, 
    image, 
    url, 
    type = 'website', 
    jsonLd,
    breadcrumbs,
    author,
    datePublished,
    dateModified,
    keywords,
    twitterHandle = '@africaresearchuniversity',
    lang = 'en'
}) => {
    // Normalize URL and image
    const normalizedUrl = (url && url.startsWith('http')) ? url : `${SITE_ROOT}${url && url !== '/' ? (url.startsWith('/') ? url : `/${url}`) : ''}`;
    const normalizedImage = (image && image.startsWith('http')) ? image : `${SITE_ROOT}${image && image.startsWith('') ? image : image && image.startsWith('/') ? image : `${image || defaultMeta.image}`}`;
    const meta = { ...defaultMeta, title, description, image: normalizedImage, url: normalizedUrl, type };

    // Combine default keywords with page-specific ones
    const defaultKeywords = "Africa Research University, ARU, research, university, higher education, Bachelors, Masters, PhD, Doctorate, Philosophy, Public Health, Public Administration, Development Studies, Business Administration, Economics, Scholarships, Online Learning";
    const finalKeywords = keywords ? `${defaultKeywords}, ${keywords}` : defaultKeywords;

    return (
        <Helmet htmlAttributes={{ lang }}>
            <title>{meta.title}</title>
            <meta name="description" content={meta.description} />
            <meta name="keywords" content={finalKeywords} />
            <meta name="theme-color" content="#000000" />

            {/* Author and publication metadata */}
            {author && <meta name="author" content={author} />}
            {datePublished && <meta property="article:published_time" content={datePublished} />}
            {dateModified && <meta property="article:modified_time" content={dateModified} />}

            {/* Open Graph / Facebook */}
            <meta property="og:type" content={meta.type} />
            <meta property="og:title" content={meta.title} />
            <meta property="og:description" content={meta.description} />
            <meta property="og:image" content={meta.image} />
            <meta property="og:url" content={meta.url} />
            <meta property="og:site_name" content="Africa Research University" />

            {/* Twitter Card */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={meta.title} />
            <meta name="twitter:description" content={meta.description} />
            <meta name="twitter:image" content={meta.image} />
            {twitterHandle && <meta name="twitter:creator" content={twitterHandle} />}

            {/* Canonical */}
            <link rel="canonical" href={meta.url} />

            {/* Basic robots */}
            <meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />

            {/* Structured data (JSON-LD) */}
            {jsonLd && (
                <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
            )}
            {breadcrumbs && breadcrumbs.length > 0 && (
                <script type="application/ld+json">
                    {JSON.stringify({
                        '@context': 'https://schema.org',
                        '@type': 'BreadcrumbList',
                        'itemListElement': breadcrumbs.map((item, index) => ({
                            '@type': 'ListItem',
                            'position': index + 1,
                            'name': item.name,
                            'item': item.url
                        }))
                    })}
                </script>
            )}
        </Helmet>
    );
};

export default SEO;
